<app-pillar-pages-temp/>

<!-- <div class="pillar-detail-container">

    @if (viewModel$ | async; as vm) {
        @for (item of vm.content;track item) {

            <div class="pillar-detail-col1">
                <nav class="pillar-detail-menu">
                    <ul class="pillar-nav-level-1">
                        @for (navItem of vm.navItems; track navItem.title) {
                            <li class="pillar-nav-item-level-1">
                                <a [href]="navItem.relative" class="pillar-nav-link" [class.active]="isActive(navItem.relative)">
                                    {{ navItem.title }}
                                </a>

                                @if (navItem.below && navItem.below.length > 0) {
                                    <ul class="pillar-nav-level-2">
                                        @for (child of navItem.below; track child.title) {
                                            <li class="pillar-nav-item-level-2">
                                                <a [href]="child.relative" class="pillar-nav-link" [class.active]="isActive(child.relative)">
                                                    {{ child.title }}
                                                </a>

                                                @if (child.below && child.below.length > 0) {
                                                    <ul class="pillar-nav-level-3">
                                                        @for (grandchild of child.below; track grandchild.title) {
                                                            <li class="pillar-nav-item-level-3">
                                                                <a [href]="grandchild.relative" class="pillar-nav-link" [class.active]="isActive(grandchild.relative)">
                                                                    {{ grandchild.title }}
                                                                </a>
                                                            </li>
                                                        }
                                                    </ul>
                                                }
                                            </li>
                                        }
                                    </ul>
                                }
                            </li>
                        }
                    </ul>
                </nav>
            </div>
            
            <div class="pillar-detail-col2">

                <h1 [innerText]="item.title"></h1>
                <div [innerHTML]="item.body"></div>

                <div class="pillar-detail-accordion">
                    <h4>Resources</h4>
                    @for (accordionItem of item.parsedResources; track accordionItem.title; let i = $index) {
                        <h4 (click)="toggleAccordion(i)">
                            <i class="icon-angle-right" [class.open]="openStates[i]"></i>
                            {{ accordionItem.title }}
                        </h4>
                        <div *ngIf="openStates[i]" [innerHTML]="accordionItem.content"></div>
                    }
                </div>
            </div>
        }
    }        
</div> -->
